<template>
    <tr v-if="session && session.main_property && session.main_property.real_estate" class="main-property-row">
        <td v-if="columns.includes('transaction_id')" class="font-bolder">
            {{ $t("avm:real_estate:appraised") }}
        </td>

        <td v-if="columns.includes('address')" style="max-width: 200px;">
            <a
                v-if="getCountryPlugin('COMPARABLES_RE_KEY_LINKS_ENABLED')"
                class="open-modal"
                :href="`/amas/real_estate/${session.main_property.real_estate.re_key}/details/0/amas`" >
                {{session.main_property.real_estate.re_key}}
            </a>
            <span v-else>{{session.main_property.real_estate.re_key}}</span>
            <div v-if="session.main_property.real_estate.unit && session.main_property.real_estate.unit.address">
                {{session.main_property.real_estate.unit.address.full_address.replace(/(.*), (\d+) (.*)/, "$1, $3")}}
            </div>
        </td>

        <td v-if="columns.includes('component_size')">
            <div style="font-weight: 400">
                <span v-if="session.total_unit_size">
                    {{session.total_unit_size||'/'|formatSize(2)}}
                </span>
                <span v-else-if="session.total_parcel_size">
                    {{session.total_parcel_size||'/'|formatSize(2)}}
                </span>
            </div>
            <div v-if="session.total_unit_size && session.total_parcel_size" style="font-size:smaller">
                <span v-tooltip="$t('analysis:ct:total_parcel_area_in_transaction')" class="cursor-help">
                    {{$t("analysis:ct:parcel_short")}}: {{session.total_parcel_size||'/'|formatSize(2)}}
                </span>
            </div>
        </td>
        
        <td v-if="columns.includes('sizes')"></td>

        <td v-if="columns.includes('building_year_built')">
            <div style="font-weight: 400">
                {{session.main_property.year_built}}
            </div>
            <div style="font-size:smaller" v-tooltip="$t('real_estate:renovations')" v-if="session.main_property.real_estate.unit">
                <renovations-block
                    :unit="session.main_property.real_estate.unit"
                />
            </div>
        </td>

        <td v-if="columns.includes('transaction_amount_gross')"></td>
        <td v-if="columns.includes('transaction_amount_m2')"></td>
        <td v-if="columns.includes('match_score')"></td>
        <td v-if="columns.includes('options')"></td>
        <td v-if="columns.includes('options')"></td>

    </tr>
</template>

<script>
import _UnitRenovationsBlock from "../../adjustments/components/_UnitRenovationsBlock.vue";

import countrymixin from "@/mixins/countrymixin";

export default {
    name: "MainPropertyRow",
    mixins: [ countrymixin ],
    components: {
        "renovations-block": _UnitRenovationsBlock,
    },
    props:  {
        session: Object,
        columns: {
            type: Array,
            default: () => []
        },
    },
}
</script>

<style scoped>
.main-property-row td {
    background-color: white;
}
</style>